"use client";

import { QueryClient, QueryClientProvider, QueryCache } from "@tanstack/react-query";

const queryConfig = {
  queries: {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60 * 24, // 24 hours
  }
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(error, `Error React Query request. Query key: ${query.queryKey}`);
    },
  })
});

export const ReactQuery = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);